import { toast as shadcnToast } from 'sonner';

interface ToastOptions {
  title: string;
  description?: string;
  variant?: 'default' | 'success' | 'destructive';
}

export function useToast() {
  return {
    toast: ({ title, description, variant = 'default' }: ToastOptions) => {
      shadcnToast(title, {
        description,
        className:
          variant === 'success'
            ? 'bg-green-100 text-green-800'
            : variant === 'destructive'
              ? 'bg-red-100 text-red-800'
              : '',
      });
    },
  };
}
